<template>
  <v-container>
    <h2>Comentarios</h2>
    <v-divider class="mt-2 mb-2"></v-divider>
    <!--boton para agregar comentario en ver  seccion de ver perdidos -->
    <v-row justify="center" align="center" class="mt-2 mb-0">
      <v-col cols="12" md="4" sm="6">
        <v-btn @click="mostrarModal = true" rounded elevation="5" dark>
          <div class="pr-2"><v-icon> mdi-comment-edit-outline </v-icon></div>
          Agregar Comentario
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="mostrarModal" max-width="600">
      <v-card>
        <v-container>
          <v-card-text>
            <v-container>
              <form ref="form" @submit.prevent="crearComentario()">
                <v-row>
                  <v-col>
                    <v-card-title class="justify-center">
                      Crear comentario nuevo para el {{ objeto }}: {{ item.id }}
                    </v-card-title>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      outlined
                      label="Comentario"
                      v-model="comentario"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-btn type="submit" color="teal lighten-2" text
                    >Crear comentario
                  </v-btn>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mostrarModalConfirmacion" max-width="400" persistent>
      <v-card>
        <div class="text-center">
          <v-icon size="70" color="green">mdi-check-circle-outline</v-icon>
          <v-card-text class="font-weight-bold">
            <div>¡El comentario fue creado con exito!</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="teal lighten-2"
              @click="mostrarModalConfirmacion = false"
              text
              >Aceptar</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <div v-if="comentarios.length === 0">
      Este {{ objeto }} no cuenta con comentarios
    </div>
    <div v-else-if="comentarios.length > 0">
      <v-card>
        <v-card-title>
          <strong>Comentarios: </strong>
        </v-card-title>
        <v-card-text>
          <div
            v-for="(comentario, index) in comentariosOrdenados"
            :key="index"
            class="mb-2"
          >
            <h3>{{ getVendedor(comentario.usuario) }}</h3>
            <span class="ml-2 circle-msj">{{
              comentario.texto_comentario
            }}</span
            ><br />
            <span
              class="ml-4"
              v-html="getFechaLegible(comentario.fecha_creacion)"
              style="white-space: pre-line"
            ></span>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  props: ["item", "usuarios", "comentarios"],
  data() {
    return {
      //comentarios: [],
      objeto: "",
      comentario: "",
      mostrarModal: false,
      mostrarModalConfirmacion: false,
    };
  },
  methods: {
    //funcion para agregar comentarios
    async crearComentario() {
      try {
        const response = await axios.post(
          `/varios/crear_comentario?id_objeto=${this.item.id}&tipo_objeto=${this.objeto}&comentario=${this.comentario}`
        );
        console.log(JSON.stringify(response.data));
        this.$emit("pedidoModificado"); // Emitir el evento 'pedidoModificado' que se encarga de actualizar los pedidos
        this.$emit("cerrarDialog");
        this.$emit("comentarioCreado");
        //alert("Comentario creado");
        this.comentario = "";
        this.mostrarModal = false;
        this.mostrarModalConfirmacion = true;
        //this.cerrar();
        //location.reload();
      } catch (error) {
        error.log(error);
        alert(JSON.stringify(error));
      }
    },

    /*async recargarComentarios() {
      try {
        const response = axios.get(
          `/varios/get_comentario?id_objeto=${this.item.id}&tipo_objeto=${this.objeto}&comentario=${this.comentario}`
        );
        this.comentario = response.data;
        location.reload();
      } catch (error) {
        console.error("Error al actulizar los datos:", error);
        alert("Error al actulizar los datos:");
      }
    },*/
    getVendedor(vendedorId) {
      const vendedorEncontrado = this.usuarios.find(
        (usuario) => usuario.id === vendedorId
      );
      if (vendedorEncontrado) {
        return vendedorEncontrado.nombre + " ";
      }
      return "";
    },
    getFechaLegible(fechaLarga) {
      const fecha = new Date(fechaLarga);

      const año = fecha.getFullYear();
      const mes = fecha.getMonth() + 1;
      const dia = fecha.getDate();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes().toString().padStart(2, "0");

      const fechaLegible = `${dia}/${mes}/${año}`;
      const horaLegible = `${hora}:${minutos}`;

      return `${fechaLegible} ${horaLegible}`;
    },
    //arreglar la funcion getComentarios para que no de error unexpected mutation of comentarios
    /* async getComentarios() {
      try {
        const response = await axios.get(
          `/varios/get_comentarios?id_objeto=${this.item.id}&tipo_objeto=${this.objeto}`
        );
        this.comentarios = response.data;
        console.log(this.comentarios);
      } catch (error) {
        console.error(error);
      }
    },*/
    checkObjectType() {
      if (
        typeof this.item.lista_productos !== "undefined" &&
        typeof this.item.transportista !== "undefined"
      ) {
        // Check if the item object has the properties "sucursal" and "envios"
        this.objeto = "envio";
      } else if (
        typeof this.item.id !== "undefined" &&
        typeof this.item.nombre !== "undefined" &&
        typeof this.item.cliente !== "undefined"
      ) {
        // Check if the item object has the properties "id", "nombre", and "cliente"
        this.objeto = "faltante";
      } else if (
        typeof this.item.id !== "undefined" &&
        typeof this.item.productos !== "undefined" &&
        typeof this.item.cliente !== "undefined"
      ) {
        // Check if the item object has the properties "id", "productos", and "cliente"
        this.objeto = "pedido";
      } else {
        // Default case if the item object doesn't match any expected format
        this.objeto = "unknown";
      }
    },
  },
  //   mounted() {
  //     this.getComentarios();
  //   },
  cerrar() {
    this.mostrarModal = false;
  },
  created() {
    this.checkObjectType();
    //this.getComentarios();
  },
  computed: {
    comentariosOrdenados() {
      return this.comentarios.slice().sort((a, b) => {
        return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
      });
    },
    /*comentariosInverso() {
      return this.comentarios.slice();
    },
    comentariosFiltrados() {
      return this.comentariosInverso.slice(0, 3);
    },*/
  },
};
</script>

<style>
.styled-card {
  width: 100%;
  padding: 10px;
}

.circle-msj {
  background-color: #e0e0e0;
  border-radius: 15px;
  padding: 10px 15px;
  display: inline-block;
  max-width: 80%;
}
</style>
